const ua = navigator.userAgent.toLowerCase();

/**
 * 判断当前环境
 * @returns 可能值 ios / android / pc / other
 */
export const os = /(?:iphone|ipad|ipod|ios)/.test(ua)
  ? "ios"
  : /(?:android|adr )/.test(ua)
  ? "android"
  : !/mobile/.test(ua)
  ? "pc"
  : "other";

/**
 * 判断当前环境，把 ipad 当作 pc 进行识别，其他逻辑跟 os 保持一致
 * @returns 可能值 ios / android / pc / other
 */
export const os2 = /ipad/.test(ua) ? "pc" : os;

/**
 * 检测是否为微信平台环境
 */
export const isWXPlatform = /MicroMessenger/i.test(ua);

/**
 * 检测是否为 QQ 平台环境
 */
export const isQQPlatform = /QQ/i.test(ua);

export const getBrowser = function () {
  const isWx = /micromessenger/i.test(ua);
  const isWeibo=/weibo/i.test(ua);
  const isFB=/fban|fbav/i.test(ua);//return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
  const isHuaWei=/huaweibrowser/i.test(ua);
  const isVivo=/vivobrowser/i.test(ua)
  const isOppo=/heytapbrowser/i.test(ua)
  const isUC=/ucbrowser/i.test(ua);
  const isQQ=/ qq/i.test(ua);
  const isQQB=/mqqbrowser/i.test(ua);
  const isSafari=/safari/i.test(ua);
  const isChrome=/chrome|crios/i.test(ua);
  const isQuark=/quark/i.test(ua);
  if(isWx){
      return "weixin";
  }else if(isWeibo){
      return "weibo"
  }else if(isQQ){
      return "qq"
  }else if(isQQB){
      return "mqq"
  }else if(isUC){
      return "uc"
  }else if(isFB){
      return "fb"
  }else if(isHuaWei){
      return "huawei"
  }else if(isVivo){
      return "vivo"
  }else if(isOppo){
      return "oppo"
  }else if(isChrome){
      return "chrome"
  }else if(isSafari&&!isChrome){
      return "safari"
  } else if (isQuark) {
     return "quark"
  }else {
      return "other"
  }
} 
